import ContactMain from "../components/contact/contactMain";
import PageTitle from "../components/PageTitle/PageTitle";

const Contact = ()=>{
    return(
        <>
       
        <PageTitle title="say hello!" description = "What’s up! Consider this a warm ping from the dev side of the world."/>
        <ContactMain/>
         </>
    )
}

export default Contact;